import { render, staticRenderFns } from "./aging.vue?vue&type=template&id=3220ec78&scoped=true&"
import script from "./aging.vue?vue&type=script&lang=js&"
export * from "./aging.vue?vue&type=script&lang=js&"
import style0 from "./aging.vue?vue&type=style&index=0&id=3220ec78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220ec78",
  null
  
)

export default component.exports